// extracted by mini-css-extract-plugin
module.exports = {"systemMsg":"SystemMessage__systemMsg--4Vueo"};